import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import ProctorURequirements from './ProctorURequirements';

const SessionStartProctorU = observer(class SessionStartProctorU extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.checkTime = this.checkTime.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1
    }

    const { examSid, sessionSid } = this.props;

    this.props.store.ExamStore.getExam(examSid);
    this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.checkTime);
    this.props.store.SessionStore.getCurrentTime();
  }

  componentWillUnmount() {
    this.props.store.StudentStore.getStudentExams();
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  checkTime() {
    const { examSession } = this.props.store.ExamStore;
    const now = moment(this.props.store.SessionStore.currentTime);
    const sessionTime = moment(examSession.appointmentDate);
    const timeToSession = moment.duration(sessionTime.diff(now)).asMinutes();
    const sessionEnd = moment(examSession.appointmentDate).add(examSession.examConfiguration.duration, 'minutes').add(30, 'minutes');
    const timeToSessionEnd = moment.duration(sessionEnd.diff(now)).asMinutes();
    const sessionMissed = moment(examSession.appointmentDate).add(15, 'minutes');
    const timeToSessionMissed = moment.duration(sessionMissed.diff(now)).asMinutes();

    if(timeToSessionEnd <= 0) {
      this.setState({
        step: 3
      });
    } else if(timeToSession > 1) {
      this.setState({
        step: 2
      });
    }

    // If the session is not in progress
    // and the sessionMissed time is in the past
    if(
      examSession.status.toLowerCase() === 'scheduled' &&
      timeToSessionMissed <= 0
    ) {
      this.setState({
        step: 4
      });
    }
  }

  startSession(examSid, sessionSid) {
    const { ScheduleStore } = this.props.store;
    const sessionWindow = window.open();

    const callback = (url) => {
      sessionWindow.location.href = url;
    }

    ScheduleStore.startOnlineSession(examSid, sessionSid, callback, sessionWindow);
  }

  render() {
    const { store, translation } = this.props;
    const { ExamStore, SessionStore } = store;
    const { exam, examSession } = ExamStore;
    const { userTimezone } = this.props.store.SessionStore;

    if(!SessionStore.loading && exam && examSession.examConfiguration) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(1)}`}>
              <h2 className="panel__title">{translation.start.heading}</h2>

              <ul className="data--alt">
                <li>
                  <strong className="subtitle">{translation.start.title}</strong>
                  <p>{exam.title}</p>
                </li>
                <li>
                  <strong className="subtitle">{translation.start.session_date}</strong>
                  <p>{moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</p>
                </li>
                <li>
                  <strong className="subtitle">{translation.start.duration}</strong>
                  <p>{toHours(examSession.examConfiguration.duration, false, false, false)}</p>
                </li>
              </ul>

              <button
                className="btn"
                onClick={() => this.startSession(exam.sid, examSession.sid)}
              >
                {translation.continue}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(2)}`}>
              <h2 className="panel__title">{translation.early.heading}</h2>

              <p>{translation.early.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <ProctorURequirements {...this.props} />

              <button
                className="btn"
                onClick={(e) => {closeDrawer(e, this.props.parent)}}
              >
                {translation.early.button}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(3)}`}>
              <h2 className="panel__title">{translation.expired.heading}</h2>

              <p>{translation.expired.body}</p>

              <button
                className="btn"
                onClick={(e) => {closeDrawer(e, this.props.parent)}}
              >
                {translation.expired.button}
              </button>
            </div>
          </div>

          <div className="slide-wrap wrap">
            <div className={`panel panel--brief ${this.statusClass(4)}`}>
              <h2 className="panel__title">{translation.late.heading}</h2>

              <p>{translation.late.body.replace('%date%', moment.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))}</p>

              <button
                className="btn"
                onClick={(e) => {closeDrawer(e, this.props.parent)}}
              >
                {translation.late.button}
              </button>
            </div>
          </div>
        </div>
      )
    }

    return null
  }
})

export default translate('SessionStartProctorU')(SessionStartProctorU);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/SessionStartProctorU.js